import { images, getProjectImages } from "./images";

// pairFirstTwo: in the single-column layout, shows the first two images side by
// side on larger screens (no effect in the 3-across layout)
export const projects = [
  {
    title: "Figma AI growth",
    images: getProjectImages("figmaAiGrowth"),
    description:
      "Helping more people discover, try, and succeed with Figma Make and Agent. Designed upsells to drive awareness, ran experiments to improve first generations, and built new foundations for empty states, attachments, and AI credits.",
  },
  {
    title: "Figma new user onboarding",
    images: getProjectImages("figmaOnboarding"),
    description:
      "Redesigned how new users get started with Figma. Shipped intent-based product recommendations, built in-product onboarding for Make, Agent, and Figma Design, and ran a design sprint to define what’s next.",
  },
  {
    title: "Figma 0 → 1 product",
    images: getProjectImages("figmaStringManagement"),
    description:
      "Led design for String Management, a new product that makes it simple to manage writing, strings, and translations in Figma. Ran a design sprint to define the vision, then partnered with product and engineering to shape the MVP.",
  },
  {
    title: "Figma seat requests",
    images: getProjectImages("figmaSeatRequests"),
    description:
      "Significantly grew Figma's business by improving their seat request system. Introduced new request entrypoints, built a nudge system for pending requests, and designed the company's first admin dashboard.",
  },
  {
    title: "Figma paywall and trial system",
    images: getProjectImages("figmaPaywall"),
    description:
      "Significantly grew Figma's business by improving paywall and trial patterns across their product suite.",
  },
  {
    title: "Figma acquisition",
    images: getProjectImages("figmaSignup"),
    description:
      "Brought more new users into Figma. Simplified the sign-up flow, redesigned logged-out product surfaces, and designed onboarding for Figma’s new Chrome extension.",
  },
  // {
  //   title: "Figma customer retention",
  //   images: getProjectImages("figmaRetention"),
  //   description:
  //     "Designed experiences to improve long-term user retention. Projects included a new onboarding experience for users who upgrade to paid plans, and a redesign of Figma's locked state for users who churn.",
  // },
  {
    title: "Lyft app redesign",
    pairFirstTwo: true,
    images: getProjectImages("lyftAppRedesign"),
    description:
      "Was asked to join the core Rideshare bookings team to help develop a long-term vision and strategy for the Lyft app. Vision completed in 2023, app refresh shipped in 2024.",
  },
  {
    title: "Lyft foundational improvements",
    pairFirstTwo: true,
    images: getProjectImages("lyftFoundations"),
    description:
      "Led multiple foundational improvements across Lyft's product ecosystem. Redesigned the referrals surface, added bike and scooter memberships into the Lyft app, and improved the signup and login experience in partner apps.",
  },
  {
    title: "Lyft group rides",
    pairFirstTwo: true,
    images: getProjectImages("lyftGroupRides"),
    description:
      "Lyft owns and operates some of the largest bike and scooter sharing systems in the world. I led the design and development of a new group riding feature, which significantly increased ridership in its first year.",
  },
  {
    title: "Lyft activation experiments",
    pairFirstTwo: true,
    images: getProjectImages("lyftActivation"),
    description:
      "Designed a series of lightweight experiments to boost activation rates for bike and scooter users who signed up but hadn't taken their first ride.",
  },
  {
    title: "Lyft rideshare experiments",
    pairFirstTwo: true,
    images: getProjectImages("lyftRideshareExperiments"),
    description:
      "Designed a series of upsell experiments for Lyft's rideshare booking flow and experimented with alternate methods of filtering. Generated significant revenue and gathered learnings to inform the larger Lyft App redesign.",
  },
  // {
  //   title: "Lyft product quality",
  //   images: getProjectImages("lyftProductQuality"),
  //   description:
  //     "Led efforts to raise the bar for design quality across Lyft. Researched and fixed gaps in company-wide design QA processes. Created a bike & scooter design toolkit to centralize patterns and components from across all of our markets.",
  // },
  {
    title: "Betterment 401(k) admin app",
    images: getProjectImages("bettermentAdminApp"),
    description:
      "Led a major redesign of Betterment's 401(k) admin app. The redesign led to a significant reduction in customer service inquiries, despite an almost 5x increase in customers.",
  },
  {
    title: "Betterment 401(k) sales flow",
    images: getProjectImages("bettermentSalesFlow"),
    description:
      "Led the design of Betterment's first self-serve sales flow for 401(k) plans. Generated a significant increase in plan sales.",
  },
  {
    title: "Betterment 401(k) end-user experience",
    images: getProjectImages("bettermentParticipantXP"),
    description:
      "Improved the 401(k) experience for plan participants. Built a self-serve flow for customers to roll over old accounts, simplified the sign up flow, and brought 401(k) plans into the Betterment mobile app.",
  },
  // {
  //   title: "Betterment design system",
  //   images: getProjectImages("bettermentDesignSystem"),
  //   description:
  //     "Organized and led company-wide design system improvements to strengthen consistency and accessibility across all products.",
  // },
];